import FormRadioField from "./formRadioField"

const FormYesNoField = props => (
  <FormRadioField
    {...props}
    options={[
      { value: 'Yes', name: 'Yes' },
      { value: 'No', name: 'No' },
    ]}
  />
)

export default FormYesNoField